<template lang="pug">
  div(v-cloak)
    v-layout(row wrap)
      v-flex(xs12 md10 offset-md1 lg8 offset-lg2)
        v-toolbar(flat dense color="secondary")
          v-icon(class="white--text") fa-book
          v-toolbar-title(class="white--text") {{$t('policy')}}

        v-card(flat)
          v-card-text.rem9
            p.mt-2
              strong {{companyName}}（以下「当社」といいます）は、情報を取り扱うサービス提供会社として個人情報を保護し、 利用者に信頼性と安心感をご提供できるように努めて参ります。 当社は、個人情報に関する法令を遵守し、 個人情報の適切な取り扱いを実現致します。

            dl.mt-2
              ol
                li
                  dt 個人情報の取得について
                  dd 当社は、偽りその他不正の手段によらず適正に個人情報を取得致します。

                li
                  dt 個人情報の利用について
                  dd 当社は、個人情報を以下の利用目的の達成に必要な範囲内で、利用致します。 以下に定めのない目的で個人情報を利用する場合、あらかじめ利用者本人の同意を得た上で行ないます。

                  ul
                    li (1) 当社のサービスを提供するため
                    li (2) 当社から利用者へのメール送付のため

                li
                  dt 個人情報の安全管理について
                  dd 当社は、取り扱う個人情報の漏洩、滅失またはき損の防止その他の個人情報の安全管理のために必要かつ適切な措置を講じます。

                li
                  dt 個人情報の委託について
                  dd 当社は、個人情報の取り扱いの全部または一部を第三者に委託する場合は、当該第三者について厳正な調査を行い、取り扱いを委託された個人情報の安全管理が図られるよう当該第三者に対する必要かつ適切な監督を行います。
                  dd また、サービス提供業務におきまして第三者と共同して業務を遂行する場合に個人情報の取り扱いを委託する場合があります。

                li
                  dt 個人情報の第三者提供について
                  dd 当社は、個人情報保護法等の法令に定めのある場合を除き、個人情報をあらかじめ利用者本人の同意を得ることなく、第三者に提供致しません。

                li
                  dt 個人情報の開示・訂正等について
                  dd 当社は、利用者から自己の個人情報についての開示の請求がある場合、速やかに開示を致します。その際、利用者本人であることが確認できない場合には、開示に応じません。
                  dd 個人情報の内容に誤りがあり、利用者本人から訂正・追加・削除の請求がある場合、調査の上、速やかにこれらの請求に対応致します。その際、利用者本人であることが確認できない場合には、これらの請求に応じません。 当社の個人情報の取り扱いにつきまして、上記の請求・お問い合わせ等ございましたら、下記までご連絡くださいますようお願い申し上げます。

                  ul
                    li 【 個人情報お問い合せ窓口 】 電話 : {{tel}} E-mail : {{email}}
                    li 【 個人情報保護管理責任者 】 当社 カスタマーコンタクト

                li
                  dt 組織・体制
                  dd 当社は、 代表取締役社長 を個人情報管理責任者とし、個人情報の適正な管理及び継続的な改善を実施致します。

                li
                  dt 本方針の変更
                  dd 本方針の内容は変更されることがあります。
                  dd 変更後の本方針については、当社が別途定める場合を除いて、当サイトに掲載した時から効力を生じるものとします。
</template>

<script>
export default {
  data () {
    return {
      companyName: '株式会社 大谷商会',
      tel: '025-274-7111',
      email: 'info@otani-shokai.com'
    }
  }
}
</script>

<style scoped lang="stylus">
ol, ul {
  padding-left: 24px;
}

ol li {
  list-style-type: decimal;
}

ul li {
  list-style-type: none;
}

dt {
  margin-top: 0.8rem;
  margin-bottom: 0.4rem;
  font-weight: bold;
}

dd {
  font-size: 0.9rem;
  margin-left: 0.4rem;
}
</style>



// WEBPACK FOOTER //
// src/common/pages/Policy/index.vue